<p class="title"><img src="assets/arrow-left.svg" class="backbutton" (click)="back()">{{ resolution.name }}</p>
<app-preview-resolution-item *ngFor="let choice of resolution.choices, let index = index" [choice]="choice" [index]="index"></app-preview-resolution-item>
